import { InactivityHandler } from '@tassat/authentication';
import axios, { AxiosRequestConfig } from 'axios';
import React, { useContext } from 'react';

import { ConstantsContext, INACTIVITY_WARNING_DURATION, LOGOUT_OFFSET_DURATION } from 'Lib/constant';
import { getUserInfo } from 'Lib/logging/getUserInfo';
import { useAppDispatch, useAppSelector } from 'Reducers/store/hooks';
import { setUserEventTriggered, uiInactivity } from 'Reducers/ui';
import { getUiInactive } from 'Selectors/common';

import { InactivityHTimerProps } from './types';

export const InactivityTimer = (props: InactivityHTimerProps) => {
    const {
        locationPath,
        logout
    } = props;

    const inactive = useAppSelector(getUiInactive);
    const userEventTriggered = useAppSelector((state) => state.ui.userEventTriggered);
    const dispatch = useAppDispatch();
    const uiConstants = useContext(ConstantsContext);
    const warningDuration = React.useMemo(() => Number(uiConstants?.inactivityWarningDuration), [uiConstants?.inactivityWarningDuration]);
    const logoutOffset = React.useMemo(() => Number(uiConstants?.inactivityLogoutOffset), [uiConstants?.inactivityLogoutOffset]);

    const logMessage = React.useCallback(async (message: string) => {
        const user = getUserInfo();

        const req: AxiosRequestConfig = {
            method: 'POST',
            url: '/log',
            data: {
                level: 'info',
                message,
                userId: user?.userId || '',
                userEmail: user?.email || '',
                username: user?.username || ''
            }
        };

        try {
            await axios(req);
        } catch (error) {
            console.error('Could not send error to loggin service');

            return;
        }
    }, []);

    const inactiveWarningDispatch = React.useCallback(() => {
        dispatch(uiInactivity());
    }, [dispatch]);

    const userEventTriggeredDispatch = React.useCallback(() => {
        if (!userEventTriggered) {
            dispatch(setUserEventTriggered());
        }
    }, [ dispatch, userEventTriggered ]);

    return (
        <InactivityHandler
            exemptedRoutes={['ssoLogout']}
            inactive={inactive}
            inactiveWarningDispatch={inactiveWarningDispatch}
            inactivityWarningDuration={!isNaN(warningDuration) &&
                warningDuration > 0 ?
                warningDuration
                : INACTIVITY_WARNING_DURATION}
            locationPath={locationPath}
            log={logMessage}
            logout={logout}
            logoutOffsetDuration={!isNaN(logoutOffset) &&
                logoutOffset > 0 ?
                logoutOffset
                : LOGOUT_OFFSET_DURATION}
            userEventTriggeredDispatch={userEventTriggeredDispatch}
        />
    );
};